import { POST_METHOD, PUT_METHOD, DELETE_METHOD, Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/users';

export default {
  getTenants(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenants`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantAllowedRoles(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/allowed_roles`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantMappedRoles(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/mapped_roles`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantRoles(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/roles`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantSecurityGroups(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/security_groups`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantUsers(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/users`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTrackToken(userId) {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/admin/user/${userId}/track_token`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getUsers() {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  postCapability(capabilityData) {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/commands/toggleCapability`, {
      body: capabilityData,
      method: POST_METHOD,
      authType: AuthEnum.TENANT,
      preventAbort: true,
    });
    return request.send();
  },
  postChangePassword(userId, passwordData) {
    const request = new Request(`${baseURL}/${userId}/commands/changePassword`, {
      body: passwordData,
      method: POST_METHOD,
      preventAbort: true,
    });
    return request.send();
  },
  postDefaultUserTenant(userId, tenantId) {
    const request = new Request(`${baseURL}/${userId}/default_tenant`, {
      body: tenantId,
      method: POST_METHOD,
      preventAbort: true,
    });
    return request.send();
  },
  postForgotPassword(forgotData) {
    const request = new Request(`${baseURL}/commands/requestPasswordReset`, {
      body: forgotData,
      method: POST_METHOD,
      authType: AuthEnum.WITHOUT,
      withoutClaims: true,
    });
    return request.send();
  },
  postResetPassword(resetPasswordData) {
    const request = new Request(`${baseURL}/commands/resetPassword`, {
      body: resetPasswordData,
      method: POST_METHOD,
      authType: AuthEnum.WITHOUT,
      withoutClaims: true,
    });
    return request.send();
  },
  postTenant(tenantInfo) {
    const request = new Request(`${baseURL}/${tenantInfo.id}/tenants`, {
      body: tenantInfo,
      method: POST_METHOD,
      authType: AuthEnum.TENANT,
      preventAbort: true,
    });
    return request.send();
  },
  postTenantRoleMapping(tenantId, mapping) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/mapped_roles`, {
      body: mapping,
      method: POST_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  postTenantSecurityGroups(tenantId, groups) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/security_groups`, {
      body: groups,
      method: POST_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  postTrackTokenRead(userId, tokenData) {
    const request = new Request(`${baseURL}/${userId}/commands/readTrackToken`, {
      body: tokenData,
      method: POST_METHOD,
    });
    return request.send();
  },
  postTrackingLog(trackingData) {
    const request = new Request('/track', {
      body: trackingData,
      method: POST_METHOD,
      authType: AuthEnum.WITHOUT,
      withoutClaims: true,
      preventAbort: true,
    });
    return request.send();
  },
  postUser(userInfo) {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/admin/user`, {
      body: userInfo,
      method: POST_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  postUserMfa(userId, mfaInfo) {
    const request = new Request(`${baseURL}/${userId}/commands/updateMfaStatus`, {
      body: mfaInfo,
      method: POST_METHOD,
      preventAbort: true,
    });
    return request.send();
  },
  putDefaultUserTenant(userId, tenantId) {
    const request = new Request(`${baseURL}/${userId}/default_tenant`, {
      body: tenantId,
      method: PUT_METHOD,
      preventAbort: true,
      authType: AuthEnum.USER,
    });
    return request.send();
  },
  putTenantRoleMapping(tenantId, mapping) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/mapped_roles`, {
      body: mapping,
      method: PUT_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  putTenantSecurityGroups(tenantId, groups) {
    const request = new Request(`${baseURL}/${tenantId}/tenant//security_groups`, {
      body: groups,
      method: PUT_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  putUser(userInfo) {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/admin/user/${userInfo.id}`, {
      body: userInfo,
      method: PUT_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  deleteDefaultUserTenant(userId) {
    const request = new Request(`${baseURL}/${userId}/default_tenant`, {
      method: DELETE_METHOD,
      preventAbort: true,
    });
    return request.send();
  },
  deleteTenantRoleMapping(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/mapped_roles`, {
      method: DELETE_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  deleteTenantSecurityGroups(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/security_groups`, {
      method: DELETE_METHOD,
      preventAbort: true,
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
};
